export const HORDE_GLOSSARY_B = [
    {
        aliases: ['HEAVY'],
        definition:
            'Weapon keyword that restricts Horde movement to 3" to preserve its to-hit bonus when an enemy is visible/in-range.',
        sectionId: '5.3',
        term: '[HEAVY]',
    },
    {
        aliases: [],
        definition:
            "Core Rules (pg. 88) placement procedure Horde Mode reuses whenever a terrain objective's terrain is removed/relocated.",
        sectionId: '2.1',
        term: 'Objectives Not Within a Terrain Area',
    },
    {
        aliases: [],
        definition: 'An objective marker embodied by an actual terrain feature (vs. a bare marker).',
        sectionId: '3.9',
        term: 'Terrain Objective',
    },
    {
        aliases: [],
        definition: 'A bare (non-terrain) objective token; max 6 may exist at once.',
        sectionId: '7.1',
        term: 'Objective Marker',
    },
    {
        aliases: [],
        definition: "A player's 'own' objective, referenced by several Secret Objectives/Secondary Missions.",
        sectionId: '7.3',
        term: 'Home Objective',
    },
    {
        aliases: [],
        definition:
            "A board-quadrant zone used by Secondary Mission 'Control the Battlefield' and Secret Objective references.",
        sectionId: '7.3',
        term: 'Table Quarter',
    },
    {
        aliases: [],
        definition:
            "Reference point used by many Action definitions and the Misery 'Stray Orbital Bombardment' grid.",
        sectionId: '7.2',
        term: 'Center of the Battlefield',
    },
    {
        aliases: ['Action'],
        definition:
            "A bespoke player-activatable procedure defined with STARTS/UNITS/USE LIMIT/COMPLETES/EFFECT fields; usable by any player's units.",
        sectionId: '3.10',
        term: 'Action (Secondary Mission)',
    },
    {
        aliases: [],
        definition:
            'Same grammar as a Secondary Mission Action but restricted to only the player(s) holding that Secret Objective, and only while revealed.',
        sectionId: '3.10',
        term: 'Action (Secret Objective)',
    },
    {
        aliases: ['Early Reveal'],
        definition:
            'Secret Objective must be revealed before game end via its own trigger, or it automatically fails.',
        sectionId: '6',
        term: 'Early Reveal (tag)',
    },
    {
        aliases: ['End of Game'],
        definition: 'Secret Objective is only revealed/resolved at game end.',
        sectionId: '6',
        term: 'End of Game (tag)',
    },
    {
        aliases: ['Survival Required'],
        definition: 'Player must still have units in play/reserve at game end to complete this Secret Objective.',
        sectionId: '6',
        term: 'Survival Required (tag)',
    },
    {
        aliases: ['Secret Tally'],
        definition: 'Objective tracked via a private running counter, revealed once a threshold is hit.',
        sectionId: '7.4',
        term: 'Secret Tally (tag)',
    },
    {
        aliases: ['Multiplayer'],
        definition: 'Secret Objective only functions meaningfully with more than one player.',
        sectionId: '7.4',
        term: 'Multiplayer (tag)',
    },
    {
        aliases: ['Traitor'],
        definition: "Secret Objective whose completion works against another player's interests.",
        sectionId: '7.4',
        term: 'Traitor (tag)',
    },
    {
        aliases: [],
        definition:
            '40mm marker placed by Deploy Short Range Teleporter; enables the Teleport action between markers.',
        sectionId: '7.1',
        term: 'Teleporter',
    },
    {
        aliases: ['Teleport'],
        definition:
            'Moves a friendly unit from one Teleporter to strategic reserves then disembarks it at another Teleporter.',
        sectionId: '7.1',
        term: 'Teleport (action)',
    },
    {
        aliases: [],
        definition: '40mm marker (max 2) that damages and slows units near it.',
        sectionId: '7.1',
        term: 'Razor Wire',
    },
    {
        aliases: [],
        definition:
            "40mm marker (max 1) in No Man's Land that deals ongoing mortal-wound damage, tracked via a cumulative tally.",
        sectionId: '7.1',
        term: 'Minefield',
    },
    {
        aliases: ['FOB'],
        definition: 'Fortify marker granting bonus Supply Points for control.',
        sectionId: '7.1',
        term: 'Forward Operating Base (FOB)',
    },
    {
        aliases: [],
        definition:
            'Fortify marker (from Arm Experimental Defenses) dealing mortal wounds to nearby Horde units each Player Fight phase.',
        sectionId: '7.1',
        term: 'Warp-Relic Outpost',
    },
    {
        aliases: [],
        definition: 'Fortify marker (from Emergency Shovel Stash) buffing nearby melee attacks.',
        sectionId: '7.1',
        term: 'War Trench',
    },
    {
        aliases: [],
        definition: 'Fortify marker healing nearby Player units each Movement phase.',
        sectionId: '7.1',
        term: 'Field Hospital',
    },
    {
        aliases: [],
        definition: 'Fortify marker reducing Horde Spawn Rolls by 1 while controlled.',
        sectionId: '7.1',
        term: 'Jamming Station',
    },
    {
        aliases: [],
        definition: 'Fortify marker granting [SUSTAINED HITS 1] to nearby ranged attacks.',
        sectionId: '7.1',
        term: 'Ammo Dump',
    },
    {
        aliases: [],
        definition: 'Fortify marker granting Feel No Pain 5+ vs. out-of-range ranged attacks.',
        sectionId: '7.1',
        term: 'Shield Generator',
    },
    {
        aliases: [],
        definition:
            "Supply Point purchase that destroys one of your own units to potentially 'upgrade' it into a different unit from the matching Spawning Table bracket.",
        sectionId: '7.1',
        term: 'Field Promotion',
    },
    {
        aliases: [],
        definition: '12 SP purchase rolling a fresh spawn-style unit into your own reserves.',
        sectionId: '7.1',
        term: 'Reinforcements Arrive',
    },
    {
        aliases: [],
        definition:
            "SP-for-healing purchase (X SP -> X wounds healed, capped at missing wounds); can target any player's unit.",
        sectionId: '7.1',
        term: 'Patched Up',
    },
    {
        aliases: [],
        definition:
            "SP purchase letting a player field one of their faction's FORTIFICATION units via Deep Strike/reserves.",
        sectionId: '7.1',
        term: 'Deploy Fortification',
    },
    {
        aliases: ['Tempt Fate', 'Advanced Tactics'],
        definition: 'Purchases manipulating how many/which Secondary Missions are active.',
        sectionId: '7.1',
        term: 'Tempt Fate / Advanced Tactics',
    },
    {
        aliases: [],
        definition: '8 SP purchase (also a reward-effect) letting a player redraw/replace their Secret Objective.',
        sectionId: '7.1',
        term: 'A Change of Plans',
    },
    {
        aliases: ['FLYING', 'TOWERING'],
        definition:
            "Keywords the Misery card 'They Fly Now' grants Horde units, also making them ignore terrain for visibility.",
        sectionId: '7.2',
        term: 'FLYING / TOWERING (Horde-granted keyword)',
    },
    {
        aliases: [],
        definition:
            "Status Horde units in a Spawn Zone have automatically (with cover); also grantable by Misery 'Fog of War' alongside Stealth.",
        sectionId: '3.1',
        term: 'Hidden',
    },
    {
        aliases: [],
        definition: "See Horde Warlord; distinguished from each player's own Warlord.",
        sectionId: '4',
        term: 'Warlord (Horde)',
    },
    {
        aliases: [],
        definition:
            'The Horde does not benefit from Army or Detachment rules - only datasheet abilities and its one Primary Faction Rule.',
        sectionId: '3.1',
        term: 'Detachment/Army Rules (Horde exclusion)',
    },
    {
        aliases: ['Stratagems'],
        definition: 'The Horde never uses stratagems or gains CP.',
        sectionId: '3.1',
        term: 'Stratagems (Horde exclusion)',
    },
    {
        aliases: [],
        definition:
            'Informal term for factions whose spawning tables can roll into weak/unusable outcomes (both Knights factions cited).',
        sectionId: '1',
        term: 'Fail-case (design term)',
    },
    {
        aliases: ['X SP', 'X cost'],
        definition:
            "Recurring convention where 'X' denotes a player-chosen or roll-derived variable amount (Patched Up, Field Promotion, Deploy Fortification, and many Secondary Mission tallies).",
        sectionId: '7.1',
        term: 'X (variable cost/tally notation)',
    },
] as const;
